
import { Phone, Mail, MapPin, Instagram, Facebook, Clock } from "lucide-react";
import { motion } from "framer-motion";

interface ContactInfoProps {
  mapLink: string;
  instagramLink: string;
  facebookLink: string;
}

const ContactInfo = ({ mapLink, instagramLink, facebookLink }: ContactInfoProps) => {
  return (
    <motion.div 
      className="flex-1" 
      initial={{ opacity: 0, x: 30 }}
      whileInView={{ opacity: 1, x: 0 }}
      viewport={{ once: true }}
      transition={{ duration: 0.6, delay: 0.4 }}
    >
      <div className="bg-black p-3 md:p-6 rounded-lg shadow-lg border border-white/20 h-full">
        <h3 className="text-lg md:text-xl font-semibold mb-3 md:mb-6 text-center md:text-left">Informacje kontaktowe</h3>
        
        <div className="space-y-3 md:space-y-6">
          <div className="flex items-start">
            <div className="bg-garage-dark p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
              <Phone className="h-4 w-4 md:h-6 md:w-6 text-garage-blue" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold mb-1 text-sm md:text-base">Telefon</p>
              <a href="tel:602709327" className="text-white/90 hover:text-garage-blue transition-colors text-sm md:text-base break-all">602 709 327</a>
            </div>
          </div>
          
          <div className="flex items-start">
            <div className="bg-garage-dark p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
              <Mail className="h-4 w-4 md:h-6 md:w-6 text-garage-blue" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold mb-1 text-sm md:text-base">Email</p>
              <a href="mailto:061garageds@gmail.com" className="text-white/90 hover:text-garage-blue transition-colors text-sm md:text-base break-all">061garageds@gmail.com</a>
            </div>
          </div>
          
          <div className="flex items-start">
            <div className="bg-garage-dark p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
              <MapPin className="h-4 w-4 md:h-6 md:w-6 text-garage-blue" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold mb-1 text-sm md:text-base">Adres</p>
              <a 
                href={mapLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="text-white/90 hover:text-garage-blue transition-colors text-sm md:text-base"
              >
                Poznań, ul. Bluszczowa
              </a>
            </div>
          </div>

          <div className="flex items-start">
            <div className="bg-garage-dark p-2 md:p-3 rounded-full mr-3 md:mr-4 flex-shrink-0">
              <Clock className="h-4 w-4 md:h-6 md:w-6 text-garage-blue" />
            </div>
            <div className="min-w-0">
              <p className="font-semibold mb-1 text-sm md:text-base">Bezpłatny dojazd</p>
              <p className="text-white/90 text-sm md:text-base">W promieniu 5km od siedziby firmy (ul. Bluszczowa)</p>
            </div>
          </div>
          
          <div className="pt-3 md:pt-6">
            <p className="font-semibold mb-2 md:mb-3 text-sm md:text-base">Godziny otwarcia</p>
            <ul className="space-y-1 md:space-y-2 text-white/90">
              <li className="flex justify-between text-xs md:text-sm">
                <span>Poniedziałek - Sobota</span>
                <span>8:00 - 18:00</span>
              </li>
              <li className="flex justify-between text-xs md:text-sm">
                <span>Niedziela</span>
                <span>Zamknięte</span>
              </li>
            </ul>
          </div>

          <div className="pt-3 md:pt-6">
            <p className="font-semibold mb-2 md:mb-3 text-sm md:text-base">Happy Hours</p>
            <div className="bg-garage-blue/20 p-2 md:p-3 rounded-lg border border-garage-blue/30">
              <p className="text-garage-blue font-semibold text-sm md:text-base">15:00 - 16:00</p>
              <p className="text-white/90 text-xs md:text-sm">Specjalne promocje w tych godzinach</p>
            </div>
          </div>
          
          <div className="pt-3 md:pt-6">
            <p className="font-semibold mb-2 md:mb-3 text-sm md:text-base">Śledź nas</p>
            <div className="flex space-x-3 md:space-x-4">
              <a 
                href={instagramLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-black border border-white/20 hover:bg-blue-900 p-2 md:p-3 rounded-full transition-colors flex items-center justify-center w-10 h-10 md:w-12 md:h-12"
              >
                <Instagram className="h-4 w-4 md:h-5 md:w-5" />
              </a>
              <a 
                href={facebookLink} 
                target="_blank" 
                rel="noopener noreferrer" 
                className="bg-black border border-white/20 hover:bg-blue-900 p-2 md:p-3 rounded-full transition-colors flex items-center justify-center w-10 h-10 md:w-12 md:h-12"
              >
                <Facebook className="h-4 w-4 md:h-5 md:w-5" />
              </a>
            </div>
          </div>
        </div>
      </div>
    </motion.div>
  );
};

export default ContactInfo;
